import { supabase } from '@/integrations/supabase/client';

let cachedRealtimeAuthToken: string | null = null;
let inFlightRealtimeAuthPrime: Promise<void> | null = null;
let inFlightRealtimeAuthToken: string | null = null;
let realtimeAuthPrimeGeneration = 0;

export function clearRealtimeAuthPrimeCache(): void {
  realtimeAuthPrimeGeneration += 1;
  cachedRealtimeAuthToken = null;
  inFlightRealtimeAuthPrime = null;
  inFlightRealtimeAuthToken = null;
}

export async function applyRealtimeAuthToken(
  accessToken: string | null | undefined,
): Promise<void> {
  if (!accessToken) {
    clearRealtimeAuthPrimeCache();
    return;
  }

  if (cachedRealtimeAuthToken === accessToken) {
    return;
  }

  if (inFlightRealtimeAuthPrime !== null && inFlightRealtimeAuthToken === accessToken) {
    await inFlightRealtimeAuthPrime;
    return;
  }

  const primeGeneration = realtimeAuthPrimeGeneration + 1;
  realtimeAuthPrimeGeneration = primeGeneration;
  inFlightRealtimeAuthToken = accessToken;
  inFlightRealtimeAuthPrime = supabase.realtime.setAuth(accessToken).then(() => {
    if (
      realtimeAuthPrimeGeneration === primeGeneration &&
      inFlightRealtimeAuthToken === accessToken
    ) {
      cachedRealtimeAuthToken = accessToken;
    }
  });

  try {
    await inFlightRealtimeAuthPrime;
  } finally {
    if (
      realtimeAuthPrimeGeneration === primeGeneration &&
      inFlightRealtimeAuthToken === accessToken
    ) {
      inFlightRealtimeAuthPrime = null;
      inFlightRealtimeAuthToken = null;
    }
  }
}

export async function primeRealtimeAuthForPrivateChannel(): Promise<void> {
  const {
    data: { session },
  } = await supabase.auth.getSession();

  await applyRealtimeAuthToken(session?.access_token);
}

export function __resetRealtimeAuthPrimeForTests(): void {
  clearRealtimeAuthPrimeCache();
}
